import React, { useState, useEffect } from "react";
import LOGO from "../../assets/images/DERMASTER_NEW_LOGO.png";
import "../../assets/styles/sendemail.scss";
import { Link, useLocation } from "react-router-dom";
// import { useParams, useSearchParams } from "react-router-dom";

const SendEmail = (props: any) => {
  const { search } = useLocation();
  let query = new URLSearchParams(search);

  const [ForgotEmail, setForgotEmail] = useState<string>("");

  const getApis = async () => {
    console.log("props =>", props);
    const email = query.get("email") || "";
    console.log("email =>", email);

    setForgotEmail(email);
  };

  useEffect(() => {
    getApis();
  }, []);

  return (
    <div className="login">
      <div className="container">
        <img className="logo" src={LOGO} alt="Dermaster" />
        <div className="box">
          <div className="box-contant">
            <label className="label1">โปรดตรวจสอบอีเมลของคุณ</label>
            <label className="label1">Please check you inbox</label>
            <p className="label3">
              We have sent an email to{" "}
              <span className="textemail">{ForgotEmail}</span> Please follow the
              instructions sent in the email to reset your password
            </p>
            <div className="forgot-password">
              <Link to="/">Back to log in</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SendEmail;
